var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChevron = function SvgChevron(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 6,
    height: 10
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "chevron_svg__a",
    d: "m15 16.19-3.78-3.97a.69.69 0 0 0-1.01 0 .777.777 0 0 0 0 1.06l4.285 4.5a.69.69 0 0 0 1.01 0l4.286-4.5a.777.777 0 0 0 0-1.06.69.69 0 0 0-1.01 0z"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#chevron_svg__a",
    fill: "currentColor",
    fillRule: "evenodd",
    transform: "rotate(-90 4 16)"
  })));
};
export default SvgChevron;